import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input() breederFirstName: string;
  @Input() breederLastName: string;
  @Input() breederKennelName: string;
  @Input() termsOfUseHeader: boolean = false;

  constructor(private _router: Router) { }

  public getName(firstName, lastName, kennelName): string {
    if (kennelName){
      return this.capitalize(kennelName);
    } else {
      return this.capitalize(firstName) + " " + this.capitalize(lastName);
    }
  }

  public capitalize(name): string {
    if (typeof (name) !== 'string') {
      return '';
    } else {
      return name.charAt(0).toUpperCase() + name.slice(1);
    }
  }

  public logout(): void {
    localStorage.clear();
    this._router.navigateByUrl('login');
  }

  public shop(): void{
    window.open('https://www.eukanubabreederclub.nl/', '_blank');
  }

  public termOfUse(): void{
    this._router.navigateByUrl('termsOfUse');
  }

  public home(): void{
    this._router.navigateByUrl('overview')
  }
}
